import colors from "constants/colors";
import styled from "styled-components";

interface WidthProp {
  width: string;
}

const StyledDivider = styled.div<WidthProp>`
  height: 2px;
  background-color: ${colors.primary};
  margin-bottom: 2em;
  width: ${props => props.width};
`;

export default StyledDivider;
